import { entityStatusSideMsgValue } from '#/modules/commonComponents/table/entityStatusIconHelpers';

export const stockIssueCategorySideMsgBlocks = [
  {
    fields: [
      { label: '代號', value: 'code' },
      { label: '名稱', value: 'name' },
      { label: '狀態', value: entityStatusSideMsgValue },
      { label: '備註', value: 'remark' },
    ],
  },
];
